export const getSalePageDetail = async (domain, path) => {
  const response = await fetch(
    `https://sale-page-website-api.ccddev-technology.com/website/initData`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ domain, path })
    }
  );

  const json = await response.json();
  return json.data;  // layout
};
